<script>
	// From Lucide
	import { EllipsisVertical } from 'lucide-svelte';

	export let iconClass = '';
</script>

<EllipsisVertical class={iconClass} />
